import React, { useState } from 'react';
import Box from "@material-ui/core/Box";
import { Button, Container, createStyles, Grid, makeStyles, Paper, TextField, Theme } from "@material-ui/core";
import { connect } from "react-redux"
import { ApplicationState } from "../../redux/reducers";
import { useHistory } from "react-router-dom";
import { ICliente } from '../../entities/catalogos/ICliente';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import { Height, Search } from '@material-ui/icons';
import useCommonApi from '../../api/useCommonApi';
import LoadingDialog from '../controls/LoadingDialog';
import AgregarDireccion from '../origenDestino/AgregarDireccion';
import { IUsuario } from '../../entities/catalogos/IUsuario';
import Help, { IHelp } from '../help/Help';
import ReferenciaNumberField from '../controls/ReferenciaNumberField';
import { getDireccionDistribuidor } from "../../blocks/utility";
import { traducirButton, traducirLabel, traducirMessage } from  '../../blocks/traductor';



const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        menuButton: {
            marginRight: theme.spacing(2),
        },
        principal: {
            height: '100%',
            backgroundColor: "#fff",
            margin: "0px",
            padding: "0 0 20px 0",
        },
        button: {

            backgroundColor: "#00653b",
            color: "#fff"
        },
        table: {
            paddingTop: "50px",
            minHeight: "220px"
        },
        tr: {
            fontWeight: 600
        },
        filters: {
            backgroundColor: "#ececec",
            boxShadow: "none",
            verticalAlign: "middle",
            paddingTop: "10px"
        },
        label: {
            fontSize: '12px',
            fontWeight: 600,
            marginTop: "10px"
        },
        textField: {
            width: 180,
            backgroundColor: "#fff"
        },
        icon: {
            width: "30px",
            height: "30px",
            minWidth: "30px",
            borderRadius: "15px",
            backgroundColor: "#19754e",
            color: "#fff",
            textAlign: "right",

        },
        marginButton: {
            margin: "10px 0px 0 30px"
        }
    }),
);

interface IProps {
    nuevoRegistro: () => void
}

interface StateProps {
    cliente: ICliente
    usuario: IUsuario
    ayuda: IHelp
}



interface DispatchProps {

}

type Props = StateProps & DispatchProps

const DireccionesLista = (props: Props) => {
    

    const classes = useStyles();
    const history = useHistory();
    const [clienteId, setClienteId] = useState('');
    const [clienteNombre, setClienteNombre] = useState('');
    const [direcciones, setDirecciones] = useState<any[]>([]);
    const [showLoading, setLoading] = useState(false);
    const apiSource = useCommonApi();
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [page, setPage] = useState(0);
    const [agregaDireccion, setNuevaDireccion] = useState(false);
    const [direccion, setDireccion] = useState('');
    const [showAgregar, setShowBoton] = useState(false);

    // const handleClick = () => {
    //     history.push("/nueva-direccion");
    // }

    React.useEffect(() => {

        if (props.cliente.esPermitirAgregarDirecciones) {
            setShowBoton(true);
        }
        buscarDirecciones();

    }, []);

    const buscarDirecciones = () => {
        setLoading(true);
        getDireccion().then(data => {
            setLoading(false);
            if (data != null && data.length) {
                let direccionesDistribuidor: any[] = [];
                data.forEach(s => {
                    let distribuidor = {
                        id: s.clienteDistribuidorID,
                        nombre: s.nombreClienteDistribuidor,
                        direccion: getDireccionDistribuidor(s)
                    };
                    direccionesDistribuidor.push(distribuidor);
                });
                setDirecciones(direccionesDistribuidor);
                setPage(0);

            }
            if (!data.length) {
                setDirecciones([]);
            }
            setLoading(false);
        }).catch(error => {
            setLoading(false);

        });;
    }

    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const cerrarNuevaDireccion = (data) => {
        setNuevaDireccion(false);

    };
    const nuevoNuevaDireccion = () => {
        setNuevaDireccion(true);

    };


    const getDireccion = async () => {


        const result = await apiSource.obtenerAsync<any>("cliente-distribuidor/by-filtro/" + props.cliente.id, {
            nombre: clienteNombre != '' ? clienteNombre : null,
            distribuidor: clienteId != '' ? clienteId : null,
            direccion: direccion != '' ? direccion : null,
            filtrar: 0
        });
        return result;



    };

    return (<>

        {showAgregar &&
            <Container maxWidth="xl" className={classes.principal} >
                <Box display="flex" justifyContent="flex-end" mt={2}>
                    <Box>
                        <Button variant="contained" color="primary" onClick={nuevoNuevaDireccion}>
                            {/* Nueva Dirección */
                            traducirButton(4)}
                        </Button>
                    </Box>
                </Box>
            </Container>
        }
        <Container maxWidth="xl" className={classes.filters} >

            <Grid container spacing={3} >
                <Grid item xs={1} >
                    <div className={classes.label}>
                        {/* Id Distribuidor */
                        traducirLabel(159)}
                    </div>
                </Grid>

                <Grid item xs={2}>

                    <form className={classes.root} noValidate autoComplete="off">
                        <TextField id="outlined-basic" size="small" className={classes.textField}
                            value={clienteId}

                            onChange={e => setClienteId(e.target.value as string)}
                            variant="outlined" fullWidth
                            InputProps={{
                                inputComponent: ReferenciaNumberField as any,
                                inputProps: { precision: 0, maxLength: 15, min: 0 },
                            }}
                        />
                    </form>


                </Grid>

                <Grid item xs={1}>
                    <div className={classes.label}>
                        {/* Nombre */
                        traducirLabel(201)}
                    </div>
                </Grid>

                <Grid item xs={2}>
                    <form className={classes.root} noValidate autoComplete="off">
                        <TextField id="outlined-basic" size="small" className={classes.textField}

                            value={clienteNombre}
                            onChange={e => setClienteNombre(e.target.value)}
                            variant="outlined" fullWidth />
                    </form>
                </Grid>

                <Grid item xs={1}>
                    <div className={classes.label}>
                        {/* Dirección */
                        traducirLabel(95)}
                    </div>
                </Grid>

                <Grid item xs={2}>
                    <form className={classes.root} noValidate autoComplete="off">
                        <TextField id="outlined-basic" size="small" className={classes.textField}
                            value={direccion}
                            onChange={e => setDireccion(e.target.value)}
                            variant="outlined" fullWidth />
                    </form>
                </Grid>

                <Grid item xs={2} className={classes.marginButton} >                   
                    <Button className={classes.icon} variant="contained" color="primary" onClick={buscarDirecciones}>
                            <Search />
                    </Button>
                </Grid>
            </Grid>

        </Container>

        <Container maxWidth="xl" style={{ padding: "0" }}>
            <Grid container>
                <Grid item xs={12} className={classes.label}>
                    <Help comments={traducirMessage(79)} customStyle={{ top: "0", right: "0px" }} />
                </Grid>
            </Grid>
        </Container>

        <Container maxWidth="xl" className={classes.table}>

            <TableContainer >
                <Table aria-label="a dense table">
                    <TableHead>
                        <TableRow>
                            <TableCell className={classes.tr}>
                                {/* ID DISTRIBUIDOR */
                                traducirLabel(159)}
                            </TableCell>
                            <TableCell className={classes.tr}>
                                {/* NOMBRE */
                                traducirLabel(201)}
                            </TableCell>
                            <TableCell className={classes.tr}>
                                {/* DIRECCIÓN */
                                traducirLabel(95)}
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>

                        {(rowsPerPage > 0
                            ? direcciones.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            : direcciones
                        ).map((row, i) => (
                            <TableRow key={i}>

                                <TableCell component="th" scope="row">
                                    {row.id}
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    {row.nombre}
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    {row.direccion}
                                </TableCell>
                            </TableRow>


                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={direcciones.length}
                labelRowsPerPage=''
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
            />
        </Container>

        {showLoading &&
            /*Procesando */
            <> <LoadingDialog titulo={traducirLabel(240)} abierto={true} /></>
        }

        {
            agregaDireccion &&
            <AgregarDireccion abierto={agregaDireccion} cerrar={cerrarNuevaDireccion} confirmar={cerrarNuevaDireccion} cliente={props.cliente}
                usuario={props.usuario} esOrigen={0} esDestino={0} setDireccion={false} ayuda={props.ayuda} />
        }
    </>)
};

const mapStateToProps = (state: ApplicationState) => ({
    cliente: state.cliente,
    usuario: state.usuario
});

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(DireccionesLista);
